import React from 'react';
// import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import CraneM3S from './CraneM3S';
import {functions} from "@zhiyun-web/helper";

/**
 * 获取组件模块名称
 * @return {string}
 */
function  getComponentName(){
    return 'CraneM3S'
}

/**
 * 获取文案
 */
function getTextData(){
    let data = functions.getGlobalData(`${getComponentName()}_TextData_`+functions.getLanguage());
    if(functions.isNull(data)){
        let api = `https://www.zhiyun-tech.com/website/in18/m3s/${functions.getLanguage()}.json`;
        functions.requestGet(api,{},getTextDataFeedback);
    }
}

/**
 * 获取文案后回调
 * @param result
 */
function getTextDataFeedback(result={}){
    if(result['code']===10000){
        return false;
    }
    if(!functions.isNull(result)){//异常
        functions.setGlobalData(`${getComponentName()}_TextData_`+functions.getLanguage(),result)
    }
}


getTextData();

const root = ReactDOM.createRoot(document.getElementById('m3s_root'));
root.render(
        <CraneM3S />
);

if(functions.getWidth()>1024){
    function reRender(){
        window.location.reload();
    }

    window.addEventListener('resize', reRender);
}
